import type { ISelfRegistration, ISelfRegistrationUser } from '@/types/Data'
import type { IGetSelfRegistrationUserList, IPayloadSelfRegistration } from '@/types/Request'
import BaseService from '../BaseService'

export default class SelfRegistrationServices extends BaseService {
  GetSelfRegistrationList() {
    return this.GET<ISelfRegistration[]>(this.PATHS.GET_SELF_REGISTRATION_LIST)
  }

  CreateSelfRegistration(data: IPayloadSelfRegistration) {
    return this.POST<ISelfRegistration>(this.PATHS.CREATE_SELF_REGISTRATION, data)
  }

  UpdateSelfRegistration(data: IPayloadSelfRegistration) {
    return this.PUT<ISelfRegistration>(this.PATHS.UPDATE_SELF_REGISTRATION, data)
  }

  RegenerateSelfRegistrationToken(Id: string) {
    return this.POST<ISelfRegistration>(this.PATHS.REGENERATE_SELF_REGISTRATION_TOKEN, { Id })
  }

  DeleteSelfRegistration(Id: string) {
    return this.DELETE<boolean>(this.PATHS.DELETE_SELF_REGISTRATION, { Id })
  }

  GetSelfRegistrationUserList(payload: IGetSelfRegistrationUserList) {
    return this.GET<ISelfRegistrationUser[]>(this.PATHS.GET_SELF_REGISTRATION_USER_LIST, payload)
  }
}
